import React from 'react'

interface FileUploadContextType {
  openSystemFileSelector: () => void
  openSystemTemplateFileSelector: () => void
  openSystemUserFilesFileSelector: () => void
  openSystemWritingSampleFileSelector: () => void
  cancelUserFileUpload: (clientTmpId: string) => void
  userFilesUploadDisabled: boolean
  userFilesUploadDisabledReason?: string
}

export const FileUploadContext = React.createContext<FileUploadContextType>({
  openSystemFileSelector: () => {
    // default, in case openSystemFileSelector has not yet been defined
    console.warn('openSystemFileSelector has not been defined')
  },
  openSystemTemplateFileSelector: () => {
    // default, in case openSystemTemplateFileSelector has not yet been defined
    console.warn('openSystemTemplateFileSelector has not been defined')
  },
  openSystemUserFilesFileSelector: () => {
    // default, in case openSystemUserFilesFileSelector has not yet been defined
    console.warn('openSystemUserFilesFileSelector has not been defined')
  },
  openSystemWritingSampleFileSelector: () => {
    // default, in case openSystemWritingSampleFileSelector has not yet been defined
    console.warn('openSystemWritingSampleFileSelector has not been defined')
  },
  cancelUserFileUpload: () => {
    // default, in case cancelUserFileUpload has not yet been defined
    console.warn('cancelUserFileUpload has not been defined')
  },
  userFilesUploadDisabled: true,
  userFilesUploadDisabledReason: 'Matter Files upload is unavailable.',
})
